var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarTimesOutline = function SvgCalendarTimesOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2C16.667 2 17 2.31441 17 2.94141V4H18C19.333 4 20 4.667 20 6V14.4102L19.293 15.1182L18.083 13.9072C18.056 13.8802 18.0277 13.8549 18 13.8291V10H6V20H14.4102L13.7002 20.71C13.3272 21.083 13.0708 21.5281 12.9277 22H6C4.667 22 4 21.333 4 20V6.00391C4.00003 4.66797 4.66703 4 6 4H7V3C6.998 2.333 7.33 2 8 2C8.67 2 9.00391 2.333 9.00391 3V4H15V2.94141C15 2.31441 15.333 2 16 2ZM6 8H18V6H6V8Z",
    fill: "#3A3A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10.667 16 11 16.333 11 17C11 17.667 10.667 18 10 18H9C8.333 18.001 8 17.668 8 17C8 16.332 8.33498 15.999 9.00195 16H10Z",
    fill: "#3A3A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C10.667 12 11 12.333 11 13C11 13.667 10.667 14 10 14H9C8.333 14.001 8 13.668 8 13C8 12.332 8.33498 11.999 9.00195 12H10Z",
    fill: "#3A3A47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15.667 12 16 12.333 16 13L15.999 13.0049C15.1706 12.9763 14.3326 13.2748 13.7002 13.9072C13.6826 13.9248 13.6655 13.943 13.6484 13.9609C13.2162 13.8569 13 13.5378 13 13C13 12.332 13.335 11.999 14.002 12H15Z",
    fill: "#3A3A47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8105 19.5L15.1 16.7895C14.6906 16.3801 14.6906 15.7164 15.1 15.307C15.5094 14.8977 16.1731 14.8977 16.5824 15.307L19.293 18.0176L22.0035 15.307C22.4129 14.8977 23.0766 14.8977 23.4859 15.307C23.8953 15.7164 23.8953 16.3801 23.4859 16.7895L20.7754 19.5L23.4859 22.2105C23.8953 22.6199 23.8953 23.2836 23.4859 23.693C23.0766 24.1023 22.4129 24.1023 22.0035 23.693L19.293 20.9824L16.5824 23.693C16.1731 24.1023 15.5094 24.1023 15.1 23.693C14.6906 23.2836 14.6906 22.6199 15.1 22.2105L17.8105 19.5Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarTimesOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-times-outline.90739ada.svg";
export { ForwardRef as ReactComponent };